import { render, staticRenderFns } from "./WebOffice.vue?vue&type=template&id=05eb8fde&scoped=true"
import script from "./WebOffice.vue?vue&type=script&lang=js"
export * from "./WebOffice.vue?vue&type=script&lang=js"
import style0 from "./WebOffice.vue?vue&type=style&index=0&id=05eb8fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb8fde",
  null
  
)

export default component.exports